export const redirectTo = (url: string): void => {
    window.location.replace(url);
};
